import React from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
import LazyReveal from "../LazyReveal";
interface Props {
  eventData: any;
}

const SpecialOffersSection: React.FC<Props> = ({ eventData }) => {
  const { zipmeLink, generateLink } = useZipmeLink();

  return (
    <LazyReveal className={styles.studentSpecialOffer} style={{ background: eventData?.specialOffersSection?.sectionBgColor || '#DBD9FC' }}>
      <Container>
        <Row>
          <div className={styles.heading}>
            <h2>{eventData?.specialOffersSection?.sectionTitle}</h2>
          </div>
        </Row>
        <Row>
          <Col xl={6} lg={6} md={6} sm={12}>
            <div className={styles.stuImg}>
              <CustomImage src={eventData?.specialOffersSection?.sectionImage} width={500} height={430} alt="stuImg.png" />

            </div>
          </Col>
          <Col xl={6} lg={6} md={6} sm={12}>
            <div className={styles.OffersContent}>
              <ul className={styles.ulItem}>
                {
                  eventData?.specialOffersSection?.offers?.length > 0 &&
                  eventData?.specialOffersSection?.offers.map((offer: string, index: number) => <li key={index} className={styles.liItem}>{offer}</li>)
                }
              </ul>
              <div className={styles.anchor}>
                <a 
                onClick={() => {
                  !eventData?.meta?.jotforms[0]?.jotformid &&
                  generateLink(eventData?.externalLink);
                }}
                className={`btn btn-primary   ${
                  eventData?.meta?.jotforms[0]?.jotformid
                    ? ` ${isFrappeOrJotFormClass(eventData?.meta?.jotforms[0]?.jotformid)}`
                    : ''
                }`}
                
                >Register Now</a>
              </div>
            </div>

          </Col>
        </Row>
      </Container>
    </LazyReveal>
  )
}

export default SpecialOffersSection;
